export default __webpack_public_path__ + "static/media/black_dragon.c333acd7.png";